import { useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./TeamSection.css";
import { ArrowLeft } from 'lucide-react';


const team = [
  {
    id: 1,
    name: "Richard Omoro",
    designation: "Regional Manager | East Africa (KE, TZ & UG)",
    image: "/assets/team-1.png",
    description:
      "Richard is a seasoned aviation executive with expertise in airline distribution and travel technology across Africa. A founding member of the IATA Distribution Advisory Council, he helped shape the NDC standard and has held senior roles at Kenya Airways (Head of Global Sales & Distribution), Travelport (General Manager), and Uganda Airlines, and served as Commercial & Systems Expert on the ATCL initiative.",
  },

  {
    id: 3,
    name: "Ferraz Alfredo",
    designation: "Manager | Sabre Angola",
    image: "/assets/ferraz.jpg",
    description:
      "Ferraz Alfredo is the Country Manager for Sabre in Angola, leading market growth and strategic partnerships. With 15+ years of experience in aviation and travel technology, he has held leadership roles at Travelport Galileo, FMJA, and KAESO, and is known for his customer-focused, strategic leadership.",
  },
  {
    id: 4,
    name: "Mael Habte",
    designation: "Regional Manager | Zambia & Zimbabwe ",
    image: "/assets/team-4.jpg",
    description:
      "Mael Habte is an aviation and business development executive with 17+ years of experience across Africa and the Middle East. He has held commercial roles at Ethiopian Airlines, flydubai, and Qatar Airways, specializing in sales, market growth, and strategic account management."},

        {
    id: 2,
    name: "Yetinayet Mulugeta",
    designation: "Manager | Sabre Mozambique",
    image: "/assets/dummy.jpg",
    description:
      "An airline and travel industry professional with more than 15 years of experience and extensive expertise in Global Distribution Systems (GDS), airline operations, and travel management. As Area Manager for Ethiopian Airlines in Zimbabwe and Mozambique, she led teams and made significant contributions to driving business growth, building strong industry partnerships, and ensuring operational excellence.",
  },
];

export default function TeamSection() {
  const teamGridRef = useRef(null);
  const [activeBio, setActiveBio] = useState(null);

  const scrollCards = (direction) => {
    if (teamGridRef.current) {
      const card = teamGridRef.current.querySelector(".team-card");

      if (card) {
        const cardWidth = card.offsetWidth;
        const gap = 25;

        teamGridRef.current.scrollBy({
          left: direction === "left" ? -(cardWidth + gap) : cardWidth + gap,
          behavior: "smooth",
        });
      }
    }
  };

  const toggleBio = (id) => {
    setActiveBio((prev) => (prev === id ? null : id));
  };

  return (
    <section className="team-section section-padding">
      <h2 className="heading-title team-headings">
        Meet Our <span className="title-blue">Team</span>
      </h2>

      <p className="desc team-desc">
        Meet the experts dedicated to delivering innovative travel technology
        solutions and exceptional support across Africa.
      </p>

      {/* TEAM SLIDER*/}

      <div className="team-slider-wrapper">
        {/* LEFT ARROW */}
        <button
          className="team-arrow team-arrow-left"
          onClick={() => scrollCards("left")}
          aria-label="Previous team member"
        >
          <ChevronLeft />
        </button>

        {/* TEAM CARDS */}
        <div className="team-grid" ref={teamGridRef}>
          {team.map((member) => (
            <div
              className={`team-card ${
                activeBio === member.id ? "bio-open" : ""
              }`}
              key={member.id}
            >
              {/* FRONT CARD*/}

              <div className="team-front">
                <img src={member.image} alt={member.name} />

                <div className="team-info">
                  <h3>{member.name}</h3>

                  <p>{member.designation}</p>

                  {/* MOBILE READ BIO */}
                  <button
                    className="read-bio-btn"
                    onClick={() => toggleBio(member.id)}
                  >
                    {activeBio === member.id ? "Read Less" : "Read Bio"}
                  </button>
                </div>
              </div>

              {/*HOVER / BIO CARD*/}

              <div className="team-hover">
                <h3>{member.name}</h3>

                <h5>{member.designation}</h5>

                <div className="hover-line"></div>

                <p>{member.description}</p>

                <button
                  className="go-back-btn"
                  onClick={() => toggleBio(member.id)}
                >
                  <ArrowLeft/>
                  <span>Go Back</span>
                </button>

                <img
                  src="/assets/team-pattern.png"
                  className="team-pattern"
                  alt=""
                />
              </div>
            </div>
          ))}
        </div>

        {/* RIGHT ARROW */}
        <button
          className="team-arrow team-arrow-right"
          onClick={() => scrollCards("right")}
          aria-label="Next team member"
        >
          <ChevronRight />
        </button>
      </div>
    </section>
  );
}
